import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';

import { getGlobalAppsParams } from './getGlobalAppsParams.ts';

export const preloadGlobalApps = async () => {
	const { edition, accessStatus } = getPreloaderFnContext();

	const { webItemParams } = getGlobalAppsParams({
		edition,
		accessStatus,
	});

	return preloadWebItemLocation(webItemParams);
};
